<template>
  <div class="profile-image text-center">
    <v-btn class="edit-btn" @click="selectFile" icon>
      <v-icon color="#13a8b1" small>edit</v-icon>
    </v-btn>
    <v-img
      :src="
        general.img != ''
          ? general.img
          : general.gender == 'male'
          ? defaultAvaterMale
          : defaultAvaterfeMale
      "
      width="90"
      height="90"
    ></v-img>

    <v-file-input
      style="display: none"
      id="avatar"
      @change="onAddFile"
      accept="image/*"
    ></v-file-input>
    <v-btn
      class="close-btn"
      icon
      @click="deleteProfileImage"
      v-if="general.img"
    >
      <v-icon color="#13a8b1" small>close</v-icon>
    </v-btn>
    <p class="mt-4 main-color">
      <strong>
        {{ general.first_name }}
      </strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "EditDeleteProfileImage",
  props: ["general"],
  data() {
    return {};
  },
  methods: {
    selectFile() {
      document.getElementById("avatar").click();
    },
    onAddFile(File) {
      if (File) {
        const selectedImage = File;
        const data = new FormData();
        data.set("avatar", selectedImage);
        this.$http
          .post(this.getApiUrl + "/user/avatar", data, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: this.locale
            }
          })
          .then(response => {
            if (response.data.status.error == false) {
              this.general.img = response.data.data.path;
            }
          });
      }
    },
    deleteProfileImage() {
      if (confirm(this.$i18n.t("delete_img_confirm_message"))) {
        this.$http
          .get(this.getApiUrl + "/user/avatar/delete", {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(response => {
            if (response.data.status.error == false) {
              this.general.img = "";
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";

.profile-image {
  .v-image {
    margin: 0 auto !important;
    border-radius: 50%;
    border: 2px solid $main-color;
  }
  .close-btn {
    border: 1px solid $main-color;
    position: absolute;
    right: 36%;
    top: 40%;
    background-color: #fff !important;
  }

  .edit-btn {
    right: 36%;
    position: absolute;
    top: 1rem;
    border: 1px solid #13a8b1;
    background-color: #ffffff !important;
    display: inline-block;
    z-index: 11111;
    /* margin: 0 2rem !important */
  }
}

@media (max-width: 600px) {
  .profile-image {
    .close-btn {
      top: 55%;
    }
    .edit-btn {
      top: -1rem;
    }
  }
}
</style>
